export const minutes = [
  {
    displayName: '0:00',
    displayValue: ':00',
    value: 0,
  },
  {
    displayName: '0:05',
    displayValue: ':05',
    value: 5,
  },
  {
    displayName: '0:10',
    displayValue: ':10',
    value: 10,
  },
  {
    displayName: '0:15',
    displayValue: ':15',
    value: 15,
  },
  {
    displayName: '0:20',
    displayValue: ':20',
    value: 20,
  },
  {
    displayName: '0:25',
    displayValue: ':25',
    value: 25,
  },
  {
    displayName: '0:30',
    displayValue: ':30',
    value: 30,
  },
  {
    displayName: '0:35',
    displayValue: ':35',
    value: 35,
  },
  {
    displayName: '0:40',
    displayValue: ':40',
    value: 40,
  },
  {
    displayName: '0:45',
    displayValue: ':45',
    value: 45,
  },
  {
    displayName: '0:50',
    displayValue: ':50',
    value: 50,
  },
  {
    displayName: '0:55',
    displayValue: ':55',
    value: 55,
  },
];
